export default "__VITE_ASSET__CEj97I1G__"